import React, { Component } from 'react';
import {Table, Input, Button} from 'reactstrap';
import './PaymentsHistoryList.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { CURRENCIES } from '../../../../constants/constants';
import PaginationUniversitiesPaymentsHistory from '../../../commonComponents/paginationComponent/PaginationUniversitiesPaymentsHistory.container';
import PaginationBAsPaymentsHistory from '../../../commonComponents/paginationComponent/PaginationBAsPaymentsHistory.container';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import CommentModal from './commentModal/CommentModal.container';
import {Utils} from '../../../../utils/utils';
import Select from '../../../commonComponents/customSelect/CustomSelect.container';

export const PAYMENTS_HISTORY_MODE = {
    BA: "BA",
    UNI: "UNI"
};

const NO_DATA_LABEL = {
    [PAYMENTS_HISTORY_MODE.BA]: "no_payments_for_ba_s_label",
    [PAYMENTS_HISTORY_MODE.UNI]: "no_payments_for_uni_s_label"
};

const NAME_LABEL = {
    [PAYMENTS_HISTORY_MODE.BA]: "ba_label",
    [PAYMENTS_HISTORY_MODE.UNI]: "uni_label"
};

class PaymentsHistoryList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowData: null,
            continentFilter: null,
            countryFilter: null,
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        if (this.props.loading) {

        }
        return (
            <div className='history-payments-component-container'>
                {this.renderFilters()}
                {
                    this.props.mode === PAYMENTS_HISTORY_MODE.UNI ?
                        <PaginationUniversitiesPaymentsHistory />
                        :
                        <PaginationBAsPaymentsHistory />
                }
                {this.renderContent()}
                <CommentModal data={this.state.selectedRowData} />
            </div>
        )
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="history-payments-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="history-payments-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, 'system_payment.' + NO_DATA_LABEL[this.props.mode])}</h6>
                </div>
            );
        }
        return (
            <Table className='history-payments-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'system_payment.' + NAME_LABEL[this.props.mode])}</th>
                    <th>{_.get(this.props.translation, 'system_payment.total_aggregated_pay_label')}</th>
                    <th>{_.get(this.props.translation, 'system_payment.amount_label')}</th>
                    <th>{_.get(this.props.translation, 'system_payment.payment_date_label')}</th>
                    <th className='comment-th'>{_.get(this.props.translation, 'system_payment.comment_label')}</th>
                </tr>
                </thead>
                <tbody>
                    {this.renderPaymentsData()}
                </tbody>
            </Table>
        )
    }

    renderPaymentsData() {
        return _.map(this.props.data, (data, index) => (
            <tr key={index}>
                <td className='name-td'
                    data-th={_.get(this.props.translation, 'system_payment.' + NAME_LABEL[this.props.mode]) + ':'}>
                    {data.name}
                </td>
                <td className='total-pay-td'
                    data-th={_.get(this.props.translation, 'system_payment.total_aggregated_pay_label') + ':'}>
                    {data.totalPay.map(pay => pay.amount + ' ' + CURRENCIES[pay.currency]).join(', ')}
                </td>
                <td className='amount-td' data-th={_.get(this.props.translation, 'system_payment.amount_label') + ':'}>
                    {data.paymentAmount.amount + ' ' + CURRENCIES[data.paymentAmount.currency]}
                </td>
                <td className='payment-date-td'
                    data-th={_.get(this.props.translation, 'system_payment.payment_date_label') + ':'}>
                    {moment(data.paymentDate).format('L')}
                </td>
                <td className='comment-td'
                    data-th={_.get(this.props.translation, 'system_payment.comment_label') + ':'}>
                    {!_.isNil(data.comment) ?
                        <Button color="link" size="sm" onClick={this.onShowCommentModal(data.comment)}>
                            {_.get(this.props.translation, 'system_payment.show_label')}
                        </Button> : null}
                </td>
            </tr>
        ))
    }

    onShowCommentModal = (comment) => () => {
        this.setState({selectedRowData: comment});
        this.props.onShowComment();
    }

    renderFilters = () => {
        return (
            <div>
                <div className="filters-container">
                    <div className="date-filter-container">
                        <div className="date-from-filter-container">
                            <h6 className="date-from-label">{_.get(this.props.translation, 'system_payment.filter_date_from_label')}</h6>
                            <DatePicker
                                className="date-filter"
                                customInput={<Input/>}
                                selected={this.props.dateFromFilter}
                                selectsStart
                                startDate={this.props.dateFromFilter}
                                endDate={this.props.dateToFilter}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                onChange={this.props.onChangeDateFromFilter}
                                maxDate={moment()}
                            />
                        </div>
                        <div className="date-to-filter-container">
                            <h6 className="date-to-label">{_.get(this.props.translation, 'system_payment.filter_date_to_label')}</h6>
                            <DatePicker
                                className="date-filter"
                                customInput={<Input/>}
                                selected={this.props.dateToFilter}
                                selectsEnd
                                startDate={this.props.dateFromFilter}
                                endDate={this.props.dateToFilter}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                onChange={(value) => this.props.onChangeDateToFilter(moment(value).endOf('day'))}
                                minDate={this.props.dateFromFilter}
                                maxDate={moment()}
                            />
                        </div>
                    </div>
                    <div className="name-filter-container">
                        <h6 className="name-label">{_.get(this.props.translation, 'system_payment.name_label')}</h6>
                        <Input
                            className="name-input"
                            type='text'
                            value={this.props.nameFilter}
                            onChange={this.onChangeNameFilter}
                        />
                    </div>
                </div>
                <div className="filters-container">
                    {this.renderContinentAndCountryFilter()}
                </div>
            </div>
        )
    };

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                Object.keys(this.props.locationData),
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.state.continentFilter ? this.props.locationData[this.state.continentFilter] : null,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return [
            <div className="continent-filter-container" key="continent-filter-container">
                <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                <Select
                    className="continent-filter-select"
                    selectedOption={_.find(continentsOptions, option => option.value === this.state.continentFilter)}
                    options={continentsOptions}
                    onSelect={this.handleChangeContinentSelect}
                />
            </div>,
            <div className="country-filter-container" key="country-filter-container">
                <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                <Select
                    className="country-filter-select"
                    selectedOption={_.find(countriesOptions, option => option.value === this.state.countryFilter)}
                    options={countriesOptions}
                    onSelect={this.handleChangeCountrySelect}
                />
            </div>
        ];
    };

    handleChangeContinentSelect = (selectedOption) => {
        if (this.state.continentFilter !== selectedOption.value) {
            this.props.onChangeContinentFilter(selectedOption.value);
            this.setState({countryFilter: null});
        }
        this.setState({continentFilter: selectedOption.value});
    };

    handleChangeCountrySelect = (selectedOption) => {
        if (!selectedOption.value) {
            this.props.onChangeContinentFilter(this.state.continentFilter);
        } else {
            this.props.onChangeCountryFilter(selectedOption.value);
        }
        this.setState({countryFilter: selectedOption.value});
    };

    onChangeNameFilter = (e) => {
        this.props.onChangeNameFilter(e.target.value);
    }
}

PaymentsHistoryList.propTypes = {
    translation: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.array,
    nameFilter: PropTypes.string,
    dateFromFilter: PropTypes.object,
    dateToFilter: PropTypes.object,
    locationData: PropTypes.object,
    onMount: PropTypes.func.isRequired,
    onChangeDateFromFilter: PropTypes.func.isRequired,
    onChangeDateToFilter: PropTypes.func.isRequired,
    onChangeNameFilter: PropTypes.func.isRequired,
    onShowComment: PropTypes.func.isRequired,
    onChangeContinentFilter: PropTypes.func.isRequired,
    onChangeCountryFilter: PropTypes.func.isRequired,
};

export default PaymentsHistoryList;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/paymentsHistoryList/PaymentsHistoryList.js